import { useMemo } from 'react';
import { useGameStore } from '../../simulation/store';
import { activityColour } from '../materials';

export function CitizensLayer() {
  const citizens = useGameStore((state) => state.world.citizens);
  const setHover = useGameStore((state) => state.setHover);
  const visibleCitizens = useMemo(() => citizens.slice(0, 420), [citizens]);

  return (
    <group>
      {visibleCitizens.map((citizen) => (
        <group
          key={citizen.id}
          position={[citizen.position.x, 0.16, citizen.position.z]}
          onPointerOver={(event) => {
            event.stopPropagation();
            setHover({ citizenId: citizen.id });
          }}
        >
          <mesh castShadow position={[0, 0.08, 0]}>
            <capsuleGeometry args={[0.035, 0.12, 4, 8]} />
            <meshStandardMaterial color={activityColour(citizen.activity)} roughness={0.6} />
          </mesh>
          <mesh castShadow position={[0, 0.2, 0]}>
            <sphereGeometry args={[0.045, 8, 8]} />
            <meshStandardMaterial color="#8a6048" roughness={0.7} />
          </mesh>
        </group>
      ))}
    </group>
  );
}
